import styled from "styled-components";
import VerticalLinearStepper from "./VerticalLinearStepper";
import {useQuery} from "react-query";
import Loading from "../../Loading";
import {
    blueprintCategory,
    blueprints,
    cpx,
    regions,
    userDetails
} from "../../../../utils/const/query-key";
import apiService from "../../../../api/apiService";
import FormImage from "../../../assets/createEnvAssets/FormImage";
import {EnvProvider} from "./components/EnvironmentContext";
import {StepperProvider} from "./components/steps/StepperContext";

const FormWrapper = styled.div`
  background: var(--color-createenv-wrapper-bg-white);
  box-shadow: 0px 10px 20px var(--color-createenv-form-wrapper-box-shadow);
  display: flex;
`;

const FormImageWrapper = styled.div`
  width: 358px;
  background: var(--color-createenv-form-image-wrapper-bg);
`;

const FormStepperWrapper = styled.div`
  padding-left: 10px;
`


const CreateEnv = (props) => {

    const { createCpxEnv } = props;
    const {status: userStatus} = useQuery(userDetails, () =>
            apiService.getUser()
        , {staleTime: Infinity}
    );
    const {status: bluePrintCategoryStatus} = useQuery(blueprintCategory, () =>
            apiService.getBlueprintCategoryData(),
        {staleTime: Infinity}
    );
    const {status: getBlueprintsStatus} = useQuery(blueprints, () =>
        apiService.getBlueprints()
    );
    const {status: getRegionsStatus} = useQuery(regions, () =>
        apiService.getRegions()
    );

    const {status: isCpxStatus} = useQuery(cpx, () =>
            true
        , {staleTime: Infinity}
    );


    if (userStatus === "loading" ||
        bluePrintCategoryStatus === "loading" ||
        getBlueprintsStatus === "loading" ||
        getRegionsStatus === "loading" ||
        isCpxStatus === "loading")
    {
        return <Loading/>;
    }

    if (userStatus === "error" ||
        bluePrintCategoryStatus === "error" ||
        getBlueprintsStatus === "error" ||
        isCpxStatus === "error" ||
        getRegionsStatus === "error")
    {
        return <h1>error</h1>;
    }
    return (
        <EnvProvider createCpxEnv={createCpxEnv}>
            <FormWrapper>
                <FormImageWrapper>
                    <FormImage/>
                </FormImageWrapper>
                <FormStepperWrapper>
                    <StepperProvider createCpxEnv={createCpxEnv}>
                        <VerticalLinearStepper/>
                    </StepperProvider>
                </FormStepperWrapper>
            </FormWrapper>
        </EnvProvider>
    );
}

export default CreateEnv;
